import { c as _c } from "react/compiler-runtime";
import IconPublic from '@/components/assets/icon_language.svg';
import IconUnlisted from '@/components/assets/icon_link.svg';
import IconPrivate from '@/components/assets/icon_lock.svg';
import { Policy, PolicyOption } from '@/types/world';
import { useTranslations } from 'next-intl';
export const useRoomPolicy = () => {
  const $ = _c(25);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("profile-page.my-worlds-create-option-1-title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("profile-page.my-worlds-create-option-1-desc");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      value: "allow_any_user",
      title: t0,
      description: t1,
      Icon: IconPublic
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("profile-page.my-worlds-create-option-2-title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("profile-page.my-worlds-create-option-2-desc");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      value: "unlisted",
      title: t3,
      description: t4,
      Icon: IconUnlisted
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("profile-page.my-worlds-create-option-3-title");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("profile-page.my-worlds-create-option-3-desc");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = {
      value: "owner_only",
      title: t6,
      description: t7,
      Icon: IconPrivate
    };
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t5 || $[23] !== t8) {
    t9 = {
      public: t2,
      unlisted: t5,
      private: t8
    };
    $[21] = t2;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const ROOM_POLICY = t9;
  return ROOM_POLICY;
};